import { render, staticRenderFns } from "./updataproduct.vue?vue&type=template&id=680f6272&scoped=true&"
import script from "./updataproduct.vue?vue&type=script&lang=js&"
export * from "./updataproduct.vue?vue&type=script&lang=js&"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./updataproduct.vue?vue&type=style&index=1&id=680f6272&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680f6272",
  null
  
)

export default component.exports